// icon
import { IconHome, IconPencil, IconPhoneCalling, IconFileDescription, IconSearch, IconShoppingCart, IconCategory, IconCirclePercentage, IconNews } from "@tabler/icons-react";
// components
import Home from "../../pages/home/home";
import Detail from "../../pages/detail/Detail";
import ContactUs from "../../pages/contactUs/contactUs";
import AboutUs from "../../pages/aboutUs/aboutUs";
import Products from "../../pages/products/products";
import CartModal from "../../components/cart/cartModal";
import PaymentStatus from "../../pages/payment/payment";
import ComparePage from "../../pages/comparePage/comparePage";
import FAQ from "../../pages/faq/faq";
import Ruels from "../../pages/ruels/rules";
import Discount from "../../pages/discount/discount";
import Delivery from "../../pages/delivery/delivery";
import ShopModal from "../../components/cart/shopping";
import Blog from "../../pages/blog/blog";
import CategoryBlogPage from "../../pages/blog/pages/categoryBlog";
import CategoryDetail from "../../pages/blog/pages/blogDetail";

export const RoutesClient = [
    {
        show: false,
        mobileShow: true,
        child: false,
        label: 'خانه',
        address: '/',
        component: <Home />,
        icon: <IconHome />,
    },
    {
        show: false,
        mobileShow: true,
        child: true,
        label: 'دسته بندی',
        toggle: 'modal',
        address: '#collapse-menu',
        mobaddress: '#modal-menu',
        component: <Products />,
        icon: <IconCategory />,
    },
    {
        show: false,
        mobileShow: true,
        child: false,
        label: 'سبد خرید',
        toggle: 'modal',
        address: '/cart',
        mobaddress: '/cart',
        component: <CartModal />,
        icon: <IconShoppingCart />,
    },
    {
        show: false,
        mobileShow: true,
        child: true,
        label: 'جست و جو',
        toggle: 'modal',
        address: '#collapse-menu',
        mobaddress: '#modal-search',
        component: <Products />,
        icon: <IconSearch />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        showIcon: true,
        label: 'فروش شگفت انگیز',
        footer: false,
        address: '/discountProducts',
        component: <Discount />,
        icon: <IconCirclePercentage />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: true,
        label: 'درباره ما',
        address: '/aboutUs',
        component: <AboutUs />,
        icon: <IconPencil />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: true,
        label: 'ارتباط باما',
        address: '/contactUs',
        component: <ContactUs />,
        icon: <IconPhoneCalling />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: true,
        label: 'سوالات متداول',
        address: '/faq',
        component: <FAQ />,
        icon: <IconPhoneCalling />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: true,
        label: 'قوانین و مقررات',
        address: '/rules',
        component: <Ruels />,
        icon: <IconPhoneCalling />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: true,
        label: 'رویه ارسال کالا',
        address: '/delivery',
        component: <Delivery />,
        icon: <IconPhoneCalling />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: false,
        label: 'مجله ارس کام',
        address: '/blog',
        component: <Blog />,
        icon: <IconNews />,
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        footer: false,
        label: 'مجله ارس کام',
        address: '/blog/categories/:slug',
        component: <CategoryBlogPage />,
        icon: <IconNews />,
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        footer: false,
        label: 'مجله ارس کام',
        address: '/blog/detail/:slug',
        component: <CategoryDetail />,
        icon: <IconNews />,
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: 'توضیحات محصول',
        address: '/products/detail/:id',
        component: <Detail />,
        icon: <IconFileDescription />
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: 'سبد خرید',
        address: '/cart',
        component: <CartModal />,
        icon: <IconFileDescription />
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: 'سبد خرید',
        address: '/shop',
        component: <ShopModal />,
        icon: <IconFileDescription />
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: ' بر اساس دسته بندی',
        address: '/categories/:slug',
        component: <Products />,
        icon: <IconFileDescription />
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: ' بر اساس دسته بندی',
        address: '/payment/:status',
        component: <PaymentStatus />,
        icon: <IconFileDescription />
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: 'مقایسه محصول',
        address: '/product/compare/:slugs',
        component: <ComparePage />,
        icon: <IconFileDescription />
    }
]